"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const recoil_1 = require("recoil");
const settlementRequestDataState_1 = __importDefault(require("./settlementRequestDataState"));
require("@@/assets/i18n");
const react_i18next_1 = require("react-i18next");
const react_hook_form_1 = require("react-hook-form");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
const SettlementRequest = () => {
    const settlementRequestData = (0, recoil_1.useRecoilValue)(settlementRequestDataState_1.default);
    const { id: roomId, user_id: userId } = settlementRequestData;
    const settlementRequestForm = (0, react_hook_form_1.useForm)({
        defaultValues: settlementRequestData,
        mode: 'onChange',
    });
    const getSettlementRequestType = () => {
        const checkPathname = (matcher) => window.location.pathname.includes(matcher);
        return checkPathname('payment-request')
            ? 'payment'
            : checkPathname('withdraw-request')
                ? 'withdraw'
                : 'commission';
    };
    const settlementRequestType = getSettlementRequestType();
    const isPaymentRequest = settlementRequestType === 'payment';
    const isWithdrawRequest = settlementRequestType === 'withdraw';
    const settlementRequestAltBackFn = () => (0, functions_1.goBackOrDesignated)(`/room/${roomId}/settlement-manage`);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    (0, react_1.useEffect)(() => {
        if (!Boolean(roomId)) {
            (0, errors_1.notFoundConfirm)({ confirm, isForm: true });
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.NavHeader, { mobileHeaderTitle: t(isPaymentRequest ? '제작비 정산' : isWithdrawRequest ? '정산' : '커미션 정산'), showPCTitle: true, altBackFn: settlementRequestAltBackFn }), Boolean(roomId) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: maxWidth768 ? 'surface-bg' : 'surface-white', css: {
                            display: 'flex',
                            flexDirection: 'column',
                            rowGap: '10px',
                            '.mobile-border-bottom-gray-5': {
                                borderBottom: maxWidth768 ? '1px solid var(--gray-5)' : 0,
                            },
                            '> div': { backgroundColor: 'var(--white)' },
                        } }, { children: [(0, jsx_runtime_1.jsx)(_1.SettlementRequestBankAccount, { settlementRequestForm: settlementRequestForm }), (0, jsx_runtime_1.jsx)(_1.SettlementRequestAmount, { settlementRequestForm: settlementRequestForm, settlementRequestType: settlementRequestType }), isPaymentRequest && ((0, jsx_runtime_1.jsx)(_1.SettlementRequestProofFiles, { userId: userId, settlementRequestForm: settlementRequestForm })), (0, jsx_runtime_1.jsx)(_1.SettlementRequestRequirements, { settlementRequestForm: settlementRequestForm, isWithdrawRequest: isWithdrawRequest }), (0, jsx_runtime_1.jsx)(_1.SettlementRequestSubmit, { handleSubmit: settlementRequestForm.handleSubmit, setValue: settlementRequestForm.setValue, settlementRequestType: settlementRequestType })] })), (0, jsx_runtime_1.jsx)(_1.SettlementRequestCompanyRegister, { setValue: settlementRequestForm.setValue })] }))] }));
};
const domContainer = document.querySelector('#root');
react_dom_1.default.render((0, jsx_runtime_1.jsx)(recoil_1.RecoilRoot, { children: (0, jsx_runtime_1.jsx)(react_1.Suspense, Object.assign({ fallback: null }, { children: (0, jsx_runtime_1.jsx)(components_1.MainTheme, { children: (0, jsx_runtime_1.jsx)(SettlementRequest, {}) }) })) }), domContainer);
